import { faChevronDown, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
  adminMenuNotificationIcon,
  adminMenuSettingsIcon,
  galleryImg1,
  defaultUserImg,
} from "../../../Constants/Images";
import { Link } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { logoutAction } from "../../../Services/Store/Actions/AuthActions";

const AdminHeader = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const userType = user && user.type ? user.type : "";

  const userImg = user && user.image ? user.image : defaultUserImg;

  return (
    <div className="admin-page-header">
      {/* <div className="search-wrapper">
        <input type="text" placeholder="Search" className="form-control" />
        <span className="search-icon as-link">
          <FontAwesomeIcon icon={faSearch} />
        </span>
      </div> */}

      <div className="user-info-wrapper">
        {/* <div className="user-info-icons">
          <Link to={`/${userType}/settings`}>
            <img src={adminMenuSettingsIcon} alt="" />
          </Link>
        </div> */}
        {/* <div className="user-info-icons">
          <Link to={`/${userType}/notifications`}>
            <img src={adminMenuNotificationIcon} alt="" />
          </Link>
        </div> */}

        <Dropdown>
          <Dropdown.Toggle>
            <div className="user-infos">
              <img src={userImg} alt="" />

              <div className="user-names">
                <div className="user-name">{user && user.name}</div>
                <div className="user-email">{user && user.email}</div>
              </div>

              <FontAwesomeIcon icon={faChevronDown} />
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href={`/${user.type}/profile`}>
              Profile
            </Dropdown.Item>
            <Dropdown.Item href="#" onClick={() => logoutAction(dispatch)}>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default AdminHeader;
